export default __webpack_public_path__ + "static/media/feature-2.25294769.jpg";